import { DatePicker as DatePickerAnt, Modal, Row } from 'antd';
import IconCalendar from 'assets/Icons/iconDate';
import { dateParamSignal } from 'CalendarFilter/DatePicker';
import Box from 'components/Box';
import type { Moment as MomentType } from 'moment';
import moment from 'utils/moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import { forwardRef, useImperativeHandle, useState } from 'react';
import aptActions from 'services/actions/apt';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { ICustomerUI } from 'types/customer';
import AptByCustomerTable from './AppointmentByCustomer';
import CustomerSearchInput from './CustomerSearchInput';
const DatePickerAntUI = DatePickerAnt.generatePicker<MomentType>(momentGenerateConfig);
export type ModalCustomerAppointmentRef = {
  open: (_value: ICustomerUI | null) => void;
};
const DATE_FORMAT = 'YYYY-MM-DD';
const ModalCustomerAppointments = forwardRef<ModalCustomerAppointmentRef>((_, ref) => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [customer, setCustomer] = useState<ICustomerUI | null>(null);
  const [selectedDate, setSelectedDate] = useState<MomentType | null>(dateParamSignal.value || moment());
  const setValue = (_value: ICustomerUI | null, _date: MomentType | null) => {
    setCustomer(_value);
    const start_time = _date?.format(DATE_FORMAT);
    const customerId = _value?.id?.toString() || '';
    if (customerId)
      return dispatch(aptActions.customer.initData({ customerId, start_time, end_time: start_time }));
    dispatch(aptActions.customer.clear());
  };

  const handleOpen: ModalCustomerAppointmentRef['open'] = (_value) => {
    setOpen(true);
    const date = dateParamSignal.value || moment();
    setSelectedDate(date);
    setValue(_value, date);
  };

  const _handleChange = (d: moment.Moment | null) => {
    setSelectedDate(d);
    setValue(customer, d);
  };

  const onCancel = () => setOpen(false);
  useImperativeHandle(ref, () => ({
    open: handleOpen
  }));

  return (
    <Modal closable={false} closeIcon={null} open={open} onCancel={onCancel} width={'auto'} centered footer={null}>
      <Header>Customer Appointments</Header>
      <Box display='flex' flexDirection='column' gap='2' p='2'>
        <Box display='flex' alignItems='center' gap='2' style={{ width: '50%' }}>
          <FormControl style={{ flex: 1 }}>
            <label >Search Customer by Phone or Name</label>
            <CustomerSearchInputStyled
              v2NewApt
              preventUnknown
              autoOpenAddWhenNotFound
              v2
              value={customer}
              onChange={(_value: any) => setValue(_value, selectedDate)}
            />
          </FormControl>
          <FormControl>
            <label >Select Date</label>
            <WrapDateTime>
              <div className='icon-right'><IconCalendar /></div>
              <DatePickerStyled
                value={selectedDate}
                onChange={_handleChange}
                suffixIcon={false}
                clearIcon={false}
                allowClear={false}
                inputReadOnly
                format={'LL'}
              />
            </WrapDateTime>
          </FormControl>
        </Box>
        <AptByCustomerTable />
      </Box>
      <Footer>
        <button type="button" onClick={onCancel} className="btn">
          Close
        </button>
      </Footer>
    </Modal>
  );
});
ModalCustomerAppointments.displayName = 'ModalCustomerAppointments';
export default ModalCustomerAppointments;
const FormControl = styled.div``;
const Footer = styled.div`
  zoom: 0.8;
  display: flex;
  padding: 12px 24px 32px 24px;
  justify-content: space-between;
  gap: 12px;
  align-self: stretch;
  background: #fff;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.1);
  .btn {
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    border-radius: 4px;
    background: #d4d7e4;
    color: #1d2129;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
    &:hover {
      opacity: 0.8;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &.btn-submit {
      background: #148cf1;
      color: #fff;
    }
    &.btn-orange {
      background: #f05326;
      color: #fff;
    }
    &.btn-green {
      background: #0cb76f;
      color: #fff;
    }
    &.btn-black {
      background: #232f3e;
      color: #fff;
    }
  }
`;

const Header = styled.div`
  zoom:0.8;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;

  border-radius: 5px;
  border-bottom: 1px solid #d4d7e4;
  background: #232f3e;

  color: #fff;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
`;

const CustomerSearchInputStyled = styled(CustomerSearchInput)`
&.WrapperInputSearch.container-input .search-input {
  height: 46px;
}
`;

const WrapDateTime = styled.div`
border-radius: 5px;
border: 1px solid #7B7B7B;
background: #FFF;
display: flex;
height: 46px;
width: 15rem;
justify-content: space-between;
align-items: center;
flex-shrink: 0;
position: relative;

.icon-right {
  position: absolute;
  left: 16px;
  display: flex;
}
.ant-picker .ant-picker-input >input {
  font-size: 1rem;
}
`;

const DatePickerStyled = styled(DatePickerAntUI)`
  background: none;
  border: none;
  padding:0;
  flex:1;
  
  input {
    text-align: right;
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px !important;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    padding: 0px 16px !important;
  }

  &.ant-picker:hover,
  &.ant-picker-focused {
    border: none;
    box-shadow: none;
  }

`;
